import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import ga from 'react-ga';
import Layout from '../../components/layout/Layout';
import SubNav from '../../components/subNav/SubNav';
import Search from '../../components/search/Search';
import { searchCase, resetFilter, updateFilter, resetSearch } from '../../components/search/action';
import SearchFilterForm from './components/SearchFilterForm';
import { userCountrySelector } from '../../components/app/appSelectors';
import { searchSelector } from '../../components/search/selectors';
import Portal from './scenes/Portal';
import SearchResult from './scenes/SearchResult';
import './index.scss';

const API_BASE = process.env.REACT_APP_API_BASE;

const CaseLaw = ({ location, loading, results, search, resetFilter, updateFilter, resetSearch, userCountry }) => {
  useEffect(() => {
    ga.pageview(location.pathname);
  }, [location]);

  return (
    <Layout>
      <SubNav />
      <div className="cl-search-container">
        <Search
          placeholder="Search for legal cases"
          url={`${API_BASE}case_law/cases`}
          defaultFilters={{ country: userCountry }}
          category="Case Law"
          search={search}
          resetFilter={resetFilter}
          updateFilter={updateFilter}
          resetSearch={resetSearch}
        >
          <SearchFilterForm />
        </Search>
      </div>
      {results === null && !loading ? <Portal /> : <SearchResult />}
    </Layout>
  );
};

const mapStateToProps = state => ({ userCountry: userCountrySelector(state), ...searchSelector(state) });

const mapDispatchToProps = {
  search: searchCase,
  resetFilter,
  updateFilter,
  resetSearch
};

export default connect(mapStateToProps, mapDispatchToProps)(CaseLaw);
